import { defaultWorkspaceApiClient } from '../cloud/services/workspace-api-client';
import type { WorkspaceMetadataDeltaHead } from './types';

const METADATA_DELTA_HEAD_REUSE_MS = 500;

const recentHeads = new Map<
  string,
  {
    expiresAt: number;
    token: string;
  }
>();

export async function fetchWorkspaceMetadataDeltaHeadToken(
  workspaceId: string,
  signal?: AbortSignal
): Promise<string> {
  if (signal?.aborted) {
    throw signal.reason;
  }
  const recent = recentHeads.get(workspaceId);
  if (recent && recent.expiresAt >= Date.now()) {
    return recent.token;
  }
  if (recent) {
    recentHeads.delete(workspaceId);
  }

  const head =
    await defaultWorkspaceApiClient.requestJson<WorkspaceMetadataDeltaHead>({
      workspaceId,
      path: `/api/workspaces/${workspaceId}/metadata/changes/head`,
      category: 'metadata',
      key: 'metadata-changes:head',
      priority: 'background',
      mode: 'background',
      init: {
        method: 'GET',
        signal,
      },
    });
  recentHeads.set(workspaceId, {
    expiresAt: Date.now() + METADATA_DELTA_HEAD_REUSE_MS,
    token: head.token,
  });
  return head.token;
}

export function resetWorkspaceMetadataDeltaHeadCacheForTests(): void {
  recentHeads.clear();
}
